(function($) {
  /* ==== NAVIGATION ==== */

  /**
   * Burger Button Handler
   */
  $('.burger-wrap').click(function() {
    $('header').toggleClass('menu-open');
    $('body').toggleClass('menu-open');
  });

  $(window).on('resize', function() {
    if (window.innerWidth >= 1055) {
      if ($('.site-header').hasClass('menu-open')) {
        $('header').removeClass('menu-open');
      }
    }

    if (window.innerWidth < 1055) {
      if ($('.site-header').hasClass('search-menu-open')) {
        $('header').removeClass('search-menu-open');
      }
    }
  });

  /**
   * Search Button Handler
   */
  $('.btn-search').click(function() {
    if (window.innerWidth >= 1055) {
      // Var init
      var siteBody = $('body');
      var siteHeader = $('header');

      siteHeader.toggleClass('search-menu-open');
      siteHeader.removeClass('cat-menu-open');

      // Handle body overflow
      if (
        siteHeader.hasClass('cat-menu-open') ||
        siteHeader.hasClass('search-menu-open')
      ) {
        siteBody.addClass('modal-open');
      } else {
        siteBody.removeClass('modal-open');
      }
    }
  });

  $('.close').click(function() {
    var siteBody = $('body');
    var siteHeader = $('header');
    siteBody.removeClass('modal-open');
    siteHeader.removeClass('search-menu-open');
    siteHeader.removeClass('cat-menu-open');
  });

  /**
   * Navigation Handler
   */
  function handleNavigation() {
    var windowWidth = $(window).width();
    var windowHeight = $(window).scrollTop();
    var offset = 50;

    // Handle scroll
    if (windowHeight > offset) {
      $('.site-header').addClass('scroll');
    }

    if (windowHeight <= offset) {
      $('.site-header').removeClass('scroll');
    }
  }

  /**
   * Page Scroll Handler
   */
  $(window).scroll(function() {
    // Navigation handler
    handleNavigation();
  });

  /**
   * Page Init
   */
  $(document).ready(function() {
    // Navigation handler
    handleNavigation();
  });

  $('li.menu-item-has-children > a').on('click', function(e) {
    e.preventDefault();
  });

  $('.wrapper-menu-mobile .menu-item-has-children a').on('click', function(e) {
    if (window.innerWidth < 992) {
      $(this).stop();
      $(this)
        .next('ul')
        .slideToggle(350);
    }
  });
})(jQuery);
